module.exports = __webpack_public_path__ + "img/stars_4_and_half.0abe1476.svg";